// extracted by mini-css-extract-plugin
export default {"chatHeader":"chatbox_chatHeader__2UGJ0","messagesArea":"chatbox_messagesArea__z9t2f","chatWindow":"chatbox_chatWindow__EfLra"};